import React, { FC, HTMLAttributes, memo } from 'react';
import styled from 'styled-components';
import UserTag from './styled/UserTag';
import { COLORS } from '../constants';

export const ChatDisplayContainerStyles = `
  display: flex;
  height: fit-content;
  justify-content: flex-start;
  flex-grow: 1;
  min-width: 0;
  align-items: center;
  padding: 12px 16px;
  color: ${COLORS.TEXT_DARK};
`;

export const ChatDisplayContainer = styled.div`
  ${ChatDisplayContainerStyles}
`;

export const ChatTitleSubtitleGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: flex-start;
  min-width: 0;
  overflow: hidden;
`;

export const ChatTitleContainer = styled.div`
  display: flex;
  max-width: 100%;
  overflow: hidden;
`;

export const ChatTitleText = styled.div`
  font-family: Lato, sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: ${COLORS.TEXT_DARK};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ChatSubtitleText = styled.div`
  font-family: Lato;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  max-width: 100%;
  color: ${COLORS.TEXT_DARK};
`;

export interface ChatTitleSubtitleGroupProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  tag?: string;
  subtitle?: string;
}

export const ChatTitleSubtitleGroup: FC<ChatTitleSubtitleGroupProps> = memo(({
  title, tag = null, subtitle = null, ...props
}) => (
  <ChatTitleSubtitleGroupContainer {...props}>
    <ChatTitleContainer>
      <ChatTitleText>{title}</ChatTitleText>
      {tag && <UserTag>{tag}</UserTag>}
    </ChatTitleContainer>
    {subtitle && (
      <ChatSubtitleText>
        {subtitle}
      </ChatSubtitleText>
    )}
  </ChatTitleSubtitleGroupContainer>
));
